<template>
  <button type="button" class="btn" :class="classes" @click="onClick" v-if="isButton">

    <!-- Add icon component conditionally -->
    <Icon v-if="icon" :name="icon" class="hidden lg:block float-left mr-1 h-5 w-5 p-0" />

    <slot />

    <template v-if="chevron">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="float-right -mr-2 h-5 w-5 p-0"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </template>
  </button>
  <static-search-link class="btn" :class="classes" @click="onClick" v-else-if="isAnchor" :to="href">
    <slot />
  </static-search-link>

</template>

<script>
import Icon from "../icons/Icon.vue";
import StaticSearchLink from "./StaticSearchLink.vue";

export default {
  name: 'InputButton',
  components: {Icon, StaticSearchLink },
  props: {
    as: {
        type: String,
        validator: function (value) {
            return ['anchor','button'].includes(value);
        },
        default: "button",
    },
    block: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ''
    },
    chevron: {
      type: Boolean,
      default: false,
    },
    styleType: {
      type: String,
      validator: function (value) {
        return [
          'primary',
          'primary-o',
          'secondary',
          'secondary-o',
          'search',
          'contact',
          'contact-form',
          'contact-form-red',
          'none',
          'more-info',
          'search-county-town',
          'search-static-industry',
          'all-industries'
        ].includes(value);
      },
      default: 'primary',
    },
    href: {
        type: String,
        default: '',
    },
  },
  computed: {
    classes() {
      const classes = {
        'w-full': this.block,
        block: this.block,
        'btn-chevron': this.chevron,
        'btn-primary': this.styleType == 'primary',
        'btn-primary-o': this.styleType == 'primary-o',
        'btn-secondary': this.styleType == 'secondary',
        'btn-secondary-o': this.styleType == 'secondary-o',
        'btn-search': this.styleType == 'search',
        'btn-contact': this.styleType == 'contact',
        'btn-none': this.styleType == 'none',
        'btn-contact-form': this.styleType == 'contact-form',
        'btn-contact-form-red': this.styleType == 'contact-form-red',
        'btn-more-info': this.styleType == 'more-info',
        'btn-search-county-town': this.styleType == 'search-county-town',
        'btn-search-static-industry': this.styleType == 'search-static-industry',
        'btn-all-industries': this.styleType == 'all-industries',
      };
      return classes;
    },
    isButton() { return this.as == 'button' ? true : false },
    isAnchor() { return this.as == 'anchor' ? true : false },
  },
  methods: {
    onClick() {
        // emit onClick back to calling component
        this.$emit('onClick');
    },
  },
};
</script>
